import React, { useEffect, useState, useMemo } from 'react';
import api from '../utils/api';

const S = {
  input: { padding: '7px 10px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13, width: '100%', boxSizing: 'border-box' },
  btnBlue:  { padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' },
  btnGreen: { padding: '7px 16px', background: '#1A7A3C', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' },
  btnGhost: { padding: '5px 11px', background: 'none', border: '1px solid #DDD', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#555' },
  btnRed:   { padding: '5px 11px', background: 'none', border: '1px solid #E05040', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#C0392B' },
};

const leegForm = { artikelnummer: '', omschrijving: '', productfamilie_id: '', klant: '', tekeningnummer: '', standaard_materiaal: '', standaard_leverancier_id: '', opmerkingen: '' };

function RouteBuilder({ route, setRoute, operaties }) {
  const voegToe = () => {
    if (!operaties.length) return;
    setRoute(r => [...r, { operatie_id: operaties[0].id, volgorde: r.length + 1, label: '' }]);
  };
  const verwijder = (i) => setRoute(r => r.filter((_, j) => j !== i));
  const wijzig = (i, veld, val) => setRoute(r => r.map((s, j) => j === i ? { ...s, [veld]: val } : s));
  const verschuif = (i, richting) => {
    const doel = i + richting;
    if (doel < 0 || doel >= route.length) return;
    const nieuw = [...route];
    [nieuw[i], nieuw[doel]] = [nieuw[doel], nieuw[i]];
    setRoute(nieuw);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: '#333' }}>Routekaart ({route.length} stappen)</div>
        <button type="button" onClick={voegToe} style={S.btnBlue}>+ Stap</button>
      </div>
      {route.length === 0 && <div style={{ fontSize: 12, color: '#AAA', fontStyle: 'italic' }}>Nog geen stappen — klik op + Stap</div>}
      {route.map((stap, i) => (
        <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 6 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <button type="button" onClick={() => verschuif(i, -1)} disabled={i === 0}
              style={{ padding: '1px 6px', background: i === 0 ? '#F5F5F5' : '#E6F1FB', border: '1px solid #C5D8F0', borderRadius: 3, cursor: i === 0 ? 'default' : 'pointer', fontSize: 10, color: i === 0 ? '#CCC' : '#185FA5', lineHeight: 1 }}>▲</button>
            <button type="button" onClick={() => verschuif(i, 1)} disabled={i === route.length - 1}
              style={{ padding: '1px 6px', background: i === route.length - 1 ? '#F5F5F5' : '#E6F1FB', border: '1px solid #C5D8F0', borderRadius: 3, cursor: i === route.length - 1 ? 'default' : 'pointer', fontSize: 10, color: i === route.length - 1 ? '#CCC' : '#185FA5', lineHeight: 1 }}>▼</button>
          </div>
          <span style={{ fontSize: 11, color: '#AAA', minWidth: 18, textAlign: 'right' }}>{i + 1}</span>
          <select value={stap.operatie_id} onChange={e => wijzig(i, 'operatie_id', parseInt(e.target.value))}
            style={{ flex: 1, padding: '5px 8px', border: '1px solid #DDD', borderRadius: 6, fontSize: 12 }}>
            {operaties.map(o => <option key={o.id} value={o.id}>{o.nummer}. {o.naam}</option>)}
          </select>
          <input placeholder="Label (optioneel)" value={stap.label || ''} onChange={e => wijzig(i, 'label', e.target.value)}
            style={{ width: 140, padding: '5px 8px', border: '1px solid #DDD', borderRadius: 6, fontSize: 12 }} />
          <button type="button" onClick={() => verwijder(i)}
            style={{ background: 'none', border: 'none', color: '#C0392B', cursor: 'pointer', fontSize: 20, lineHeight: 1, padding: '0 4px' }}>×</button>
        </div>
      ))}
    </div>
  );
}

function FicheForm({ title, form, setForm, route, setRoute, operaties, families, leveranciers, onSla, onAnnuleer, bezig }) {
  const inp = (field) => ({
    style: S.input,
    value: form[field] || '',
    onChange: e => setForm(f => ({ ...f, [field]: e.target.value })),
  });

  return (
    <div style={{ background: '#fff', border: '1.5px solid #185FA5', borderRadius: 10, padding: 22, marginBottom: 20 }}>
      <div style={{ fontWeight: 600, fontSize: 15, color: '#1F3864', marginBottom: 18 }}>{title}</div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
        <div>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Artikelnummer</label>
          <input {...inp('artikelnummer')} placeholder="T1.2, CZ-001..." />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Omschrijving *</label>
          <input {...inp('omschrijving')} placeholder="Naam van het product" />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Productfamilie</label>
          <select style={S.input} value={form.productfamilie_id || ''} onChange={e => setForm(f => ({ ...f, productfamilie_id: e.target.value }))}>
            <option value="">— Kies familie —</option>
            {families.map(f => (
              <option key={f.id} value={f.id}>{f.naam}</option>
            ))}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Klant</label>
          <input {...inp('klant')} placeholder="Leeg = generiek product" />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Tekeningnummer</label>
          <input {...inp('tekeningnummer')} />
        </div>
        <div>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Standaard materiaal</label>
          <input {...inp('standaard_materiaal')} placeholder="Staaltype, afmeting..." />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Standaard leverancier</label>
          <select style={S.input} value={form.standaard_leverancier_id || ''} onChange={e => setForm(f => ({ ...f, standaard_leverancier_id: e.target.value }))}>
            <option value="">— Kies leverancier —</option>
            {leveranciers.map(l => <option key={l.id} value={l.id}>{l.naam}</option>)}
          </select>
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={{ fontSize: 11, color: '#666', display: 'block', marginBottom: 3 }}>Opmerkingen</label>
          <textarea {...inp('opmerkingen')} style={{ ...S.input, minHeight: 60, resize: 'vertical' }} />
        </div>
      </div>

      <div style={{ borderTop: '1px solid #EEE', paddingTop: 14, marginBottom: 16 }}>
        <RouteBuilder route={route} setRoute={setRoute} operaties={operaties} />
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={onSla} disabled={bezig || !form.omschrijving} style={S.btnGreen}>
          {bezig ? 'Opslaan...' : 'Opslaan'}
        </button>
        <button onClick={onAnnuleer} style={S.btnGhost}>Annuleren</button>
      </div>
    </div>
  );
}

export default function ProductFichesPage({ user }) {
  const [fiches, setFiches]           = useState([]);
  const [operaties, setOperaties]     = useState([]);
  const [families, setFamilies]       = useState([]);
  const [leveranciers, setLeveranciers] = useState([]);
  const [laden, setLaden]             = useState(true);
  const [zoek, setZoek]               = useState('');
  const [familieFilter, setFamilieFilter] = useState('');
  const [openId, setOpenId]           = useState(null);
  const [openRoute, setOpenRoute]     = useState({});
  const [toonNieuw, setToonNieuw]     = useState(false);
  const [nieuwForm, setNieuwForm]     = useState(leegForm);
  const [nieuwRoute, setNieuwRoute]   = useState([]);
  const [bewerkFiche, setBewerkFiche] = useState(null);
  const [bewerkRoute, setBewerkRoute] = useState([]);
  const [bezig, setBezig]             = useState(false);
  // volgorde-bewerking in kaartweergave: { ficheId, stappen: [...] } | null
  const [volgordeEdit, setVolgordeEdit] = useState(null);
  const [volgordeBezig, setVolgordeBezig] = useState(false);

  const isPlanner = ['planner', 'admin'].includes(user?.rol);

  const laad = async () => {
    const [f, o, fam, l] = await Promise.all([
      api.get('/productfiches'), api.get('/operaties'),
      api.get('/productfamilies'), api.get('/leveranciers'),
    ]);
    setFiches(f.data); setOperaties(o.data); setFamilies(fam.data); setLeveranciers(l.data);
    setLaden(false);
  };

  useEffect(() => { laad(); }, []);

  const toggleOpen = async (fiche) => {
    if (openId === fiche.id) { setOpenId(null); return; }
    setOpenId(fiche.id);
    if (!openRoute[fiche.id]) {
      const r = await api.get(`/productfiches/${fiche.id}`);
      setOpenRoute(prev => ({ ...prev, [fiche.id]: r.data.route || [] }));
    }
  };

  const openBewerk = async (fiche) => {
    const r = await api.get(`/productfiches/${fiche.id}`);
    setBewerkFiche({
      id: fiche.id,
      artikelnummer: fiche.artikelnummer || '',
      omschrijving: fiche.omschrijving || '',
      productfamilie_id: fiche.productfamilie_id || '',
      klant: fiche.klant || '',
      tekeningnummer: fiche.tekeningnummer || '',
      standaard_materiaal: fiche.standaard_materiaal || '',
      standaard_leverancier_id: fiche.standaard_leverancier_id || '',
      opmerkingen: fiche.opmerkingen || '',
    });
    setBewerkRoute(r.data.route?.map(s => ({
      operatie_id: s.operatie_id,
      volgorde: s.volgorde,
      label: s.label || '',
    })) || []);
  };

  const slaAanmaken = async () => {
    setBezig(true);
    try {
      await api.post('/productfiches', { ...nieuwForm, route: nieuwRoute.map((s, i) => ({ ...s, volgorde: i + 1 })) });
      setToonNieuw(false); setNieuwForm(leegForm); setNieuwRoute([]);
      await laad();
    } catch (e) { alert('Fout: ' + (e.response?.data?.error || e.message)); }
    setBezig(false);
  };

  const slaBewerk = async () => {
    setBezig(true);
    try {
      await api.put(`/productfiches/${bewerkFiche.id}`, {
        ...bewerkFiche,
        route: bewerkRoute.map((s, i) => ({ ...s, volgorde: i + 1 })),
      });
      setBewerkFiche(null);
      setOpenRoute(prev => { const n = { ...prev }; delete n[bewerkFiche.id]; return n; });
      await laad();
    } catch (e) { alert('Fout: ' + (e.response?.data?.error || e.message)); }
    setBezig(false);
  };

  const dupliceer = async (fiche) => {
    if (!window.confirm(`"${fiche.omschrijving}" dupliceren?`)) return;
    try {
      await api.post(`/productfiches/${fiche.id}/dupliceer`);
      await laad();
    } catch (e) { alert('Fout: ' + (e.response?.data?.error || e.message)); }
  };

  const deactiveer = async (fiche) => {
    if (!window.confirm(`Productfiche "${fiche.omschrijving}" deactiveren? Ze verdwijnt uit de lijst.`)) return;
    try {
      await api.delete(`/productfiches/${fiche.id}`);
      setFiches(f => f.filter(x => x.id !== fiche.id));
    } catch (e) { alert(e.response?.data?.error || e.message); }
  };

  const startVolgordeEdit = (ficheId) => {
    const stappen = [...(openRoute[ficheId] || [])].sort((a, b) => a.volgorde - b.volgorde);
    setVolgordeEdit({ ficheId, stappen });
  };

  const verschuifFicheStap = (index, richting) => {
    const doel = index + richting;
    if (!volgordeEdit || doel < 0 || doel >= volgordeEdit.stappen.length) return;
    const nieuw = [...volgordeEdit.stappen];
    [nieuw[index], nieuw[doel]] = [nieuw[doel], nieuw[index]];
    setVolgordeEdit(v => ({ ...v, stappen: nieuw }));
  };

  const slaFicheVolgordeOp = async () => {
    if (!volgordeEdit) return;
    setVolgordeBezig(true);
    try {
      const stappen = volgordeEdit.stappen.map((s, i) => ({ id: s.id, volgorde: i + 1 }));
      await api.patch(`/productfiches/${volgordeEdit.ficheId}/route/volgorde`, { stappen });
      // Lokaal bijwerken
      const bijgewerkt = volgordeEdit.stappen.map((s, i) => ({ ...s, volgorde: i + 1 }));
      setOpenRoute(prev => ({ ...prev, [volgordeEdit.ficheId]: bijgewerkt }));
      setVolgordeEdit(null);
    } catch (e) { alert('Fout: ' + (e.response?.data?.error || e.message)); }
    setVolgordeBezig(false);
  };

  const gefilterd = useMemo(() => fiches.filter(f => {
    if (familieFilter && String(f.productfamilie_id) !== familieFilter) return false;
    if (zoek) {
      const q = zoek.toLowerCase();
      return `${f.artikelnummer || ''} ${f.omschrijving} ${f.klant || ''} ${f.familie_naam || ''}`.toLowerCase().includes(q);
    }
    return true;
  }), [fiches, familieFilter, zoek]);

  return (
    <div style={{ padding: 24 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: '#1F3864' }}>Productfiches</h1>
          <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
            {laden ? '...' : `${fiches.length} fiches`}
          </div>
        </div>
        {isPlanner && (
          <button onClick={() => { setToonNieuw(!toonNieuw); setBewerkFiche(null); }} style={S.btnBlue}>
            {toonNieuw ? '× Annuleren' : '+ Nieuwe fiche'}
          </button>
        )}
      </div>

      {/* Nieuw-form */}
      {toonNieuw && (
        <FicheForm
          title="Nieuwe productfiche"
          form={nieuwForm} setForm={setNieuwForm}
          route={nieuwRoute} setRoute={setNieuwRoute}
          operaties={operaties} families={families} leveranciers={leveranciers}
          onSla={slaAanmaken} onAnnuleer={() => { setToonNieuw(false); setNieuwForm(leegForm); setNieuwRoute([]); }}
          bezig={bezig}
        />
      )}

      {/* Zoek + familiefilter */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap', alignItems: 'center' }}>
        <input value={zoek} onChange={e => setZoek(e.target.value)}
          placeholder="Zoeken op artikel, omschrijving, klant, familie..."
          style={{ flex: 1, minWidth: 220, padding: '7px 12px', border: '1px solid #DDD', borderRadius: 6, fontSize: 13 }} />
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button onClick={() => setFamilieFilter('')} style={{
            padding: '6px 12px', borderRadius: 6, fontSize: 12, cursor: 'pointer', border: '1px solid #DDD',
            background: !familieFilter ? '#1F3864' : '#fff', color: !familieFilter ? '#fff' : '#555',
          }}>Alle families</button>
          {families.filter(f => f.actief !== false).map(f => (
            <button key={f.id} onClick={() => setFamilieFilter(familieFilter === String(f.id) ? '' : String(f.id))} style={{
              padding: '6px 12px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
              border: familieFilter === String(f.id) ? `1.5px solid ${f.kleur || '#185FA5'}` : '1px solid #DDD',
              background: familieFilter === String(f.id) ? (f.kleur ? f.kleur + '22' : '#E6F1FB') : '#fff',
              color: familieFilter === String(f.id) ? (f.kleur || '#185FA5') : '#555',
              fontWeight: familieFilter === String(f.id) ? 600 : 400,
            }}>
              {f.naam}
            </button>
          ))}
        </div>
      </div>

      {/* Resultaat */}
      {laden ? (
        <div style={{ color: '#888', fontSize: 13, padding: 24, textAlign: 'center' }}>Laden...</div>
      ) : gefilterd.length === 0 ? (
        <div style={{ color: '#AAA', fontStyle: 'italic', padding: 24, textAlign: 'center' }}>Geen productfiches gevonden</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
          {gefilterd.map(f => {
            const isOpen = openId === f.id;
            const route = openRoute[f.id] || [];

            return (
              <div key={f.id} style={{
                background: '#fff', border: '1px solid #E0E0E0', borderRadius: 10,
                overflow: 'hidden', transition: 'box-shadow 0.15s',
              }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                {/* Familie-kleurstip */}
                {f.familie_kleur && <div style={{ height: 4, background: f.familie_kleur }} />}

                {/* Kaart inhoud */}
                <div style={{ padding: '14px 16px' }}>
                  {/* Bovenrij */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {f.artikelnummer && (
                        <div style={{ fontSize: 11, color: '#185FA5', fontWeight: 700, marginBottom: 2 }}>{f.artikelnummer}</div>
                      )}
                      <div style={{ fontSize: 15, fontWeight: 600, color: '#1F3864', lineHeight: 1.3 }}>{f.omschrijving}</div>
                    </div>
                    {f.familie_naam && (
                      <span style={{
                        fontSize: 10, padding: '2px 8px', borderRadius: 99, marginLeft: 8, flexShrink: 0,
                        background: f.familie_kleur ? f.familie_kleur + '22' : '#E6F1FB',
                        color: f.familie_kleur || '#0C447C', border: `1px solid ${f.familie_kleur || '#BDD4EE'}`,
                      }}>{f.familie_naam}</span>
                    )}
                  </div>

                  {/* Details */}
                  <div style={{ fontSize: 12, color: '#555', marginBottom: 10 }}>
                    {f.klant && <div style={{ marginBottom: 2 }}>Klant: <strong>{f.klant}</strong></div>}
                    {f.tekeningnummer && <div style={{ marginBottom: 2 }}>Tekening: {f.tekeningnummer}</div>}
                    {f.standaard_materiaal && <div style={{ marginBottom: 2 }}>Materiaal: {f.standaard_materiaal}</div>}
                    {f.leverancier_naam && <div>Leverancier: {f.leverancier_naam}</div>}
                  </div>

                  {/* Statistieken */}
                  <div style={{ display: 'flex', gap: 16, marginBottom: 12 }}>
                    <span style={{ fontSize: 11, color: '#888' }}>
                      <strong style={{ color: '#185FA5' }}>{f.stap_count}</strong> stappen
                    </span>
                    <span style={{ fontSize: 11, color: '#888' }}>
                      <strong style={{ color: parseInt(f.order_count) > 0 ? '#1A7A3C' : '#AAA' }}>{f.order_count}</strong> orders
                    </span>
                  </div>

                  {/* Route uitklappen */}
                  <button onClick={() => toggleOpen(f)} style={{
                    width: '100%', padding: '6px', background: '#F7F9FC', border: '1px solid #E8E8E8',
                    borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#555', marginBottom: 10,
                    textAlign: 'left',
                  }}>
                    {isOpen ? '▲ Route verbergen' : '▼ Route bekijken'}
                  </button>

                  {/* Route stappen */}
                  {isOpen && (
                    <div style={{ marginBottom: 10, background: '#F7F9FC', borderRadius: 8, padding: '10px 12px' }}>
                      {/* Header met volgorde-knop */}
                      {isPlanner && route.length > 1 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                          {volgordeEdit?.ficheId === f.id ? (
                            <div style={{ display: 'flex', gap: 6, alignItems: 'center', width: '100%' }}>
                              <span style={{ fontSize: 11, color: '#854F0B', fontWeight: 500, flex: 1 }}>Volgorde aanpassen</span>
                              <button onClick={slaFicheVolgordeOp} disabled={volgordeBezig}
                                style={{ padding: '3px 10px', background: '#1A7A3C', color: '#fff', border: 'none', borderRadius: 5, fontSize: 11, cursor: 'pointer', fontWeight: 600 }}>
                                {volgordeBezig ? 'Opslaan...' : '✓ Opslaan'}
                              </button>
                              <button onClick={() => setVolgordeEdit(null)}
                                style={{ padding: '3px 8px', background: 'none', border: '1px solid #DDD', borderRadius: 5, fontSize: 11, cursor: 'pointer', color: '#555' }}>
                                Annuleren
                              </button>
                            </div>
                          ) : (
                            <button onClick={() => startVolgordeEdit(f.id)}
                              style={{ padding: '2px 8px', background: 'none', border: '1px solid #CCC', borderRadius: 5, fontSize: 10, cursor: 'pointer', color: '#666', marginLeft: 'auto', display: 'block' }}>
                              ↕ Volgorde aanpassen
                            </button>
                          )}
                        </div>
                      )}

                      {route.length === 0 ? (
                        <div style={{ fontSize: 12, color: '#AAA', fontStyle: 'italic' }}>Geen stappen gedefinieerd</div>
                      ) : volgordeEdit?.ficheId === f.id ? (
                        // Volgorde-bewerkmodus
                        volgordeEdit.stappen.map((stap, i) => (
                          <div key={stap.id || i} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 0', borderBottom: i < volgordeEdit.stappen.length - 1 ? '1px solid #EEE' : 'none' }}>
                            <span style={{ fontSize: 10, color: '#AAA', minWidth: 16, textAlign: 'right' }}>{i + 1}</span>
                            <span style={{ fontSize: 12, color: '#333', flex: 1 }}>{stap.label || stap.operatie_naam}</span>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                              <button onClick={() => verschuifFicheStap(i, -1)} disabled={i === 0}
                                style={{ padding: '1px 5px', background: i === 0 ? '#F5F5F5' : '#E6F1FB', border: '1px solid #C5D8F0', borderRadius: 3, cursor: i === 0 ? 'default' : 'pointer', fontSize: 9, color: i === 0 ? '#CCC' : '#185FA5', lineHeight: 1 }}>▲</button>
                              <button onClick={() => verschuifFicheStap(i, 1)} disabled={i === volgordeEdit.stappen.length - 1}
                                style={{ padding: '1px 5px', background: i === volgordeEdit.stappen.length - 1 ? '#F5F5F5' : '#E6F1FB', border: '1px solid #C5D8F0', borderRadius: 3, cursor: i === volgordeEdit.stappen.length - 1 ? 'default' : 'pointer', fontSize: 9, color: i === volgordeEdit.stappen.length - 1 ? '#CCC' : '#185FA5', lineHeight: 1 }}>▼</button>
                            </div>
                          </div>
                        ))
                      ) : (
                        // Normale weergave
                        route.map((stap, i) => (
                          <div key={stap.id || i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderBottom: i < route.length - 1 ? '1px solid #EEE' : 'none' }}>
                            <span style={{ fontSize: 10, color: '#AAA', minWidth: 16, textAlign: 'right' }}>{i + 1}</span>
                            <span style={{ fontSize: 12, color: '#333', flex: 1 }}>
                              {stap.label || stap.operatie_naam}
                            </span>
                            {stap.is_extern && (
                              <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 99, background: '#FAEEDA', color: '#633806' }}>extern</span>
                            )}
                          </div>
                        ))
                      )}
                    </div>
                  )}

                  {/* Actieknoppen */}
                  {isPlanner && (
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => { openBewerk(f); setToonNieuw(false); }} style={S.btnGhost}>Bewerk</button>
                      <button onClick={() => dupliceer(f)} style={S.btnGhost}>Dupliceer</button>
                      <button onClick={() => deactiveer(f)} style={{ ...S.btnRed, marginLeft: 'auto' }}>Deactiveer</button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Bewerk-modal */}
      {bewerkFiche && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: '100%', maxWidth: 700, boxShadow: '0 8px 32px rgba(0,0,0,0.2)', marginBottom: 40 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: 17, color: '#1F3864' }}>Fiche bewerken</h2>
              <button style={S.btnGhost} onClick={() => setBewerkFiche(null)}>✕</button>
            </div>
            <FicheForm
              title=""
              form={bewerkFiche} setForm={setBewerkFiche}
              route={bewerkRoute} setRoute={setBewerkRoute}
              operaties={operaties} families={families} leveranciers={leveranciers}
              onSla={slaBewerk} onAnnuleer={() => setBewerkFiche(null)}
              bezig={bezig}
            />
          </div>
        </div>
      )}

      {/* Footer */}
      {!laden && (
        <div style={{ marginTop: 16, fontSize: 12, color: '#AAA', textAlign: 'center' }}>
          {gefilterd.length} fiche{gefilterd.length !== 1 ? 's' : ''} weergegeven{fiches.length !== gefilterd.length ? ` (van ${fiches.length})` : ''}
        </div>
      )}
    </div>
  );
}
